<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-row class="d-flex flex-column" align="center" justify="start">
          <Logo height="25vh" />

          <h1 class="headline mb-3">{{ $t("Log in to MerloCode") }}</h1>
          <v-card flat min-width="30vw" height="40vh">
            <v-card-text>
              <v-form>
                <v-text-field
                  :label="$t('email')"
                  outlined
                  flat
                  dense
                  name="email"
                  v-model="email"
                  prepend-inner-icon="mdi-account"
                  type="text"
                  @keydown.enter="logIn"
                />

                <v-text-field
                  id="password"
                  label="Password"
                  outlined
                  flat
                  dense
                  name="password"
                  v-model="password"
                  prepend-inner-icon="mdi-lock"
                  type="password"
                  @keydown.enter="logIn"
                />
              </v-form>
              <v-row dense class="d-flex caption mx-12 justify-space-between" align="end">
                <a class="text-left" @click="clickedForgotPassword">{{ $t("Forgot password?") }}</a>
                <a class="text-right" @click="clickedNotRegistered">{{ $t("Not registered?") }}</a>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined large class="px-8" @click="logIn">{{ $t("Log in") }}</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AuthService from "@/service/auth_service";
import router from "@/router/index";
import Logo from "@/views/dashboard/components/Logo";

export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  components: { Logo },
  methods: {
    async logIn() {
      // TODO Do something if error
      await AuthService.logIn(this.email, this.password);
    },
    clickedForgotPassword() {
      router.replace("/restorepassword");
    },
    clickedNotRegistered() {
      router.replace("/signup");
    }
  },
  mounted() {
    AuthService.onAuthStateChanged(user => {
      if (user) {
        this.$gtag.event("login", { method: "Google" });
        if (AuthService.emailVerified) {
          router.replace("/");
        }
      }
    });
  }
};
</script>
